import { createPortal } from "react-dom";
import { Mic } from "@safers/ui/atoms";

interface RecordingIndicatorProps {
  transcript: string;
  onStop: () => void;
}

export function RecordingIndicator({ transcript, onStop }: RecordingIndicatorProps) {
  return createPortal(
    <div
      className="fixed inset-0 z-[1100] flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={onStop}
      role="dialog"
      aria-modal="true"
      aria-label="음성 인식 중"
    >
      <div
        className="relative flex h-44 w-44 items-center justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="absolute inset-0 animate-ping rounded-full bg-red-500/30" />
        <span className="absolute inset-6 animate-ping rounded-full bg-red-500/20 [animation-delay:0.4s]" />
        <div className="relative flex h-28 w-28 items-center justify-center rounded-full bg-red-500 text-white shadow-lg ring-8 ring-white/20">
          <Mic size="xl" />
        </div>
      </div>

      <p className="mt-8 max-w-[80vw] text-center text-xl font-medium text-white drop-shadow">
        {transcript || "듣고 있어요…"}
      </p>
      <p className="mt-3 text-sm text-white/60">말을 멈추면 자동 실행 · 화면 탭/Esc 로 취소</p>
    </div>,
    document.body
  );
}
